import React  from 'react';
import './App.css';
import './YearlyExpenses.css';
import { useNavigate } from "react-router-dom";
import DashboardLang from './DashboardLang.json';

import ToolbarPopupMenu from "./ToolbarPopupMenu.js"

class YearlyExpensesToolbar extends React.Component {

	constructor(props) {

		super(props);
				
		this.state = {
			innerWidth: 0,
			innerHeight: 0,
			showPopupMenuYN: false,
			variableNameArray: null,
		}

		this.updateDimensions = this.updateDimensions.bind(this);
		this.populateVariableNameArray = this.populateVariableNameArray.bind(this);
		this.handleSelectDashboard = this.handleSelectDashboard.bind(this);
		this.handleSelectLink = this.handleSelectLink.bind(this);
		this.handlePopupLink = this.handlePopupLink.bind(this);
		this.closePopupMenu = this.closePopupMenu.bind(this);
		this.renderLink = this.renderLink.bind(this);
		this.renderRight = this.renderRight.bind(this);
	}
	
	componentDidMount() {
		this.updateDimensions();
		window.addEventListener('resize', this.updateDimensions);
		this.populateVariableNameArray();
	}

	componentWillUnmount() {
		document.removeEventListener('resize', this.updateDimensions, true);
	};
	
	updateDimensions = () => {
		this.setState({ innerWidth: window.innerWidth, innerHeight: window.innerHeight });
	};
	
	populateVariableNameArray() {

		var dashboardVariableListMonthlyJsonObj = this.props.dashboardVariableListMonthlyJsonObj;
		if (dashboardVariableListMonthlyJsonObj === null) {
			return;
		}
		
		var dashboardAppUserType = this.props.dashboardAppUserType;
		var dashboardUserType = this.props.dashboardUserType;

		var showSalaryYN = false;
		if (dashboardAppUserType >= 100) {
			showSalaryYN = true;
		}
		if (dashboardUserType === 3) {
			showSalaryYN = true;
		}
		if (dashboardUserType === 102) {
			showSalaryYN = true;
		}

		var calcHelpersObj = this.props.calcHelpersObj;
		var i;
		var variableName;
		var itemObj;
		var skipVariableYN;
		var salaryYN;
		var variableNameArray = [];
		
		for(i=0; i<dashboardVariableListMonthlyJsonObj.length; i++) {

			itemObj = dashboardVariableListMonthlyJsonObj[i];
			variableName = itemObj.variableName;
			
			skipVariableYN = false;
			if (!showSalaryYN) {
				salaryYN = calcHelpersObj.isVariableSalaryYN(variableName);
				if (salaryYN) {
					skipVariableYN = true;
				}
			}
			

			if (!skipVariableYN) {
				variableNameArray.push(variableName);
			}
		}

		variableNameArray.push("totalstaff");
		variableNameArray.push("totalexpenses");
		
		var tab = this.props.tab;
		if (tab === "") {
			this.props.setTab(variableNameArray[0]);
		}

		this.setState({
			variableNameArray: variableNameArray,
		});
	}
	
	handleSelectDashboard() {
		const navigate = this.props.navigate;
  		navigate("/selectdashboard");
	}
	
	handleSelectLink(tab) {
		this.props.setTab(tab);
	}
	
	handlePopupLink() {
		this.setState({showPopupMenuYN: true});
	}

	closePopupMenu() {
		this.setState({showPopupMenuYN: false});
	}
	
	renderLink(linkTitle, linkValue, key, selectedYN) {

		var classNameString = "DashboardMainToolbarLink";
					
		if (selectedYN) {
			classNameString = "DashboardMainToolbarSelectedLink";
		}
		
		return (
			<div 
				key={key}
				className={classNameString}
				onClick={() => this.handleSelectLink(linkValue)}
			>
				{linkTitle}
			</div>
		);
	}
	
	renderPopupLink(linkTitle, variableNameArray) {

		var classNameString = "DashboardMainToolbarSelectedLink";
		
		return (
			<div 
				key="popup-link"
				className={classNameString}
			>
				<div 
					className={classNameString}
					onClick={() => this.handlePopupLink()}
				>
					{linkTitle}
				</div>
				{this.state.showPopupMenuYN && (
					<ToolbarPopupMenu
						variableNameArray={variableNameArray}
						handleSelectLink={this.handleSelectLink}
						getLang={this.props.getLang}
						closePopupMenu={this.closePopupMenu}
					/>
				)}
			</div>
		);
	}
	
	renderRight() {
		
		var variableNameArray = this.state.variableNameArray;
		if (variableNameArray === null) {
			return;
		}
		
		var innerWidth = this.state.innerWidth;
		
		var displayPopupYN = true;
		/*if (innerWidth < 1200) {
			displayPopupYN = true;
		}*/
		
		var tab = this.props.tab;
		var selectedYN;

		var i;
		var variableName;
		var jsxCode;
		var jsxArray = [];
		var key1;
		var key2;
		var variableString;

		if (displayPopupYN) {

			for(i=0; i<variableNameArray.length; i++) {
				
				variableName = variableNameArray[i];
				variableString = this.props.getLang(DashboardLang, variableName);

				selectedYN = false;
				if (tab === variableName) {
					selectedYN = true;
				}

				if (selectedYN) {
					jsxCode = this.renderPopupLink(variableString, variableNameArray);
					jsxArray.push(jsxCode);
				}				
			}
			
			return jsxArray;
		}

		for(i=0; i<variableNameArray.length; i++) {
			
			if (i>0) {
				key1 = "a-" + i;
				jsxCode = (<div key={key1} className="DashboardMainToolbarText">|</div>);
				jsxArray.push(jsxCode);
			}

			key2 = "b-" + i;

			variableName = 	variableNameArray[i];
			variableString = this.props.getLang(DashboardLang, variableName);

			selectedYN = false;
			if (tab === variableName) {
				selectedYN = true;
			}

			jsxCode = this.renderLink(variableString, variableName, key2, selectedYN);
			jsxArray.push(jsxCode);
		}

		return jsxArray;
	}
	
	render() {
		
		var dashboardName = this.props.dashboardName;
		var dataTip = this.props.getLang(DashboardLang, "selectDashboard");
		
		return (
			<div className="YearlyExpensesToolbarContainer1">
				<div className="YearlyExpensesToolbarLeft">
					<div 
						className="YearlyExpensesToolbarLink"
						onClick={() => this.handleSelectDashboard()}
						data-tip={dataTip}
					>
						{dashboardName}
					</div>
				</div>
				<div className="YearlyExpensesToolbarRight">
					<div className="YearlyExpensesToolbarContainer2">
						{this.renderRight()}
					</div>
				</div>
			</div>
		);
	}
}

export default function YearlyExpensesToolbarFunction(props) {
	const navigate = useNavigate();
	return <YearlyExpensesToolbar {...props} navigate={navigate} />;
}

